export type messagesState = any[];

export const GET_MESSAGES_SUCCESS = 'messages/GET_MESSAGES_SUCCESS';
export const READ_MESSAGE_REQUEST = 'messages/READ_MESSAGE_REQUEST';
export const READ_MESSAGE_SUCCESS = 'messages/READ_MESSAGE_SUCCESS';
